import {
  BrazeUser,
  ContactUsProblem,
  Franchise,
  NonFoodOrder,
  PickupType,
  UserOrderInfo,
  VirtualGiftCard,
  VirtualGiftCardOrder
} from '@core/redux/stores';
import { ContactUs } from '@core/redux/stores/contact-us.store';
import { CustomerInfo } from '@core/redux/stores/guest.store';
import { LocationsEntity } from '@core/redux/stores/location.store';
import {
  ConfirmAndPay,
  DeliveryAddress,
  Order,
  OrderGuestPaymentInfo,
  OrderPaymentInfo,
  SubmitOrderRequest
} from '@core/redux/stores/order.store';
import { TokenInfo } from '@core/redux/stores/token-info.store';
import { User } from '@core/redux/stores/user.store';


export class AuthObj {
  isLoggedIn: boolean;
  tokenInfo: TokenInfo;

  constructor() {
    this.tokenInfo = new TokenInfo();
  }
}

export interface IAppState {
  auth: AuthObj;

  // THIS GUEST INFO IS A PLACEHOLDER. I am not sure if it should be like this or inside the
  // the user object. Need to think about this before implementation for guest check out.
  guest: CustomerInfo;
  user: User;

  locationSelected: LocationsEntity;
  activeOrder: Order;
  activeFavorite: Order;

  // this is only used when a Guest user checks out. This will show up
  // in the Menu Landing screen for allowing a guest to reorder their
  // last order
  lastOrder: Order;

  orderPaymentInfo: OrderPaymentInfo;
  orderGuestPaymentInfo: OrderGuestPaymentInfo;

  pickuptypeSelected: PickupType;
  submittedOrder: UserOrderInfo;
  confirmAndPay: ConfirmAndPay;
  confirmAndPayOrder: SubmitOrderRequest;
  contactUs: ContactUs;
  deliveryAddress: DeliveryAddress;
  franchise: Franchise;
  virtualGiftCard: VirtualGiftCard;
  virtualGiftCardOrder: VirtualGiftCardOrder;
  brazeUser: BrazeUser;
  nonFoodOrder: NonFoodOrder;
  contactUsProblem: ContactUsProblem
}

export const INITIAL_STATE: IAppState = {
  auth: new AuthObj(),

  guest: new CustomerInfo(),
  user: new User(),

  locationSelected: null,
  activeOrder: null,
  activeFavorite: null,
  lastOrder: null,
  pickuptypeSelected: null,
  submittedOrder: null,
  orderPaymentInfo: null,
  orderGuestPaymentInfo: null,
  confirmAndPay: null,
  confirmAndPayOrder: null,
  contactUs: null,
  deliveryAddress: null,
  franchise: null,
  virtualGiftCard: null,
  virtualGiftCardOrder: null,
  brazeUser: null,
  nonFoodOrder: null,
  contactUsProblem: null,
};
